/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


const base = {
    API_KEY: 'WDXJHOqFDPzIj8LLf5LQFNqUJQzUo8uv',
    API_ORGANIZATOIN: 'Pearson',
    CLIENT_ID: 'sWzPLSMPFeOaO4N5TJ08j3L4oCnQd41I',
    FUSION_CHART_KEY: 'TBD',
    IES_BASE_URL: 'https://login-stg.pearson.com/v1/piapi-int/',
    PRODUCT_MODEL_REGION: 'Everest',

    EVEREST_HELP_URL: 'https://www.pearsonschoolsandfecolleges.co.uk/help/activelearn-guides-for-teachers/insights-dashboard',
    MORE_ABOUT_INSIGHTS: 'https://www.pearsonschoolsandfecolleges.co.uk/secondary/activelearn#insights-dashboard',

    ALS_MARK_BOOK: 'app/reports/markbook/list',

    //End points
    ASSESSMENT_END_POINT: 'assessment/v1',
    COMMON_END_POINT: 'common/v1',
    USER_END_POINT: 'getUserData',
    STUDENT_END_POINT: 'student/v1',
    STUDENT_FETCH_QUERY: 'getStudents',
    STUDENTS:'student',
    GROUP_END_POINT:'groups/v1',
    GROUP: 'groups',

    ACADEMIC_YEAR_LIST: [{ "id": "2018", "label": "2018-2019" }, { "id": "2019", "label": "2019-2020" }, { "id": "2020", "label": "2020-2021" },{ "id": "2021", "label": "2021-2022" }]
};

export default base;